import { TcClickTypes } from '../../configuration/tagcommander'

export type TcCLickArgs = {
  click_name?: string
  click_type: string | TcClickTypes
  chapter1: string
  chapter2?: string
  chapter3?: string
  click?: string
  click_chapter1?: string
  click_chapter2?: string
  filtre?: string
}

export default function tcClick(data: TcCLickArgs) {
  if (
    !(window as typeof window & { tC: any })?.tC ||
    typeof (window as typeof window & { tC: any })?.tC?.event.click !==
      'function'
  ) {
    return
  }
  const {
    click_name,
    click_type,
    chapter1,
    chapter2,
    chapter3,
    click,
    click_chapter1,
    click_chapter2,
    filtre,
  } = data

  try {
    ;(window as typeof window & { tC: any })?.tC?.event?.click?.(undefined, {
      click_name,
      click_type,
      chapter1,
      chapter2,
      chapter3,
      click,
      click_chapter1,
      click_chapter2,
      filtre,
    })
  } catch (err) {
    console.log(err)
  }
}
